const fa = 'fa'
const icons = {
    remove: `${fa} fa-times`,
    next:  `${fa} fa-chevron-right`,
    prev:  `${fa} fa-chevron-left`,
    confirm: `${fa} fa-check`,
    edit: `${fa} fa-pencil-square-o`
}

export default icons;


// WEBPACK FOOTER //
// ./src/Constants/icons.js